import type { TaskStatusValue } from "@/types/dsd";
import { isSheetAnalyzing } from "@/components/sidebar/task-status";
import { Loader, RefreshCcw } from "lucide-react";
import { useMemo } from "react";

export const TaskStatusDisplay = ({ status }: { status: TaskStatusValue }) => {
  const display = useMemo(() => {
    if (isSheetAnalyzing(status)) {
      return <Loader className="!size-3 text-blue-500 animate-spin" />;
    }
    switch (status) {
      case "COMPLETED":
      case "NOT_TARGET":
        return null;
      case "FAILED":
        return <RefreshCcw className="!size-3 text-orange-500" />;
      default: {
        // 새 TaskStatusValue 가 생기면 여기서 컴파일 에러 — 표시 정책을 정하고
        // isSheetAnalyzing 또는 위 케이스에 추가할 것.
        const _exhaustive: never = status;
        return _exhaustive ?? null;
      }
    }
  }, [status]);

  return <div className="">{display}</div>;
};
